import { Component, OnInit } from "@angular/core";
import { AuthorizationPipe } from "../../common/pipes/authorization.pipe";

@Component({
    selector: "customer-ticket-dashboard",
    templateUrl: "../templates/template1/views/ticket-dashboard.component.html",
    styleUrls: [
        "../templates/template1/themes/default/css/ticket.less"
    ],
    providers: [AuthorizationPipe]
})
export class TicketsDashboardComponent implements OnInit {   

    ngOnInit(): void {
        this.activetab = 1;
     };
      activetab: number;
    selectTab(tab: any) {
        this.activetab = tab;
    }
    changeTab(tab: any) {
        this.activetab = tab;
    }
}


// WEBPACK FOOTER //
// ./src/app/customerservice/components/ticket-dashboard.component.ts